import { useSearchParams } from 'react-router-dom';

const SHARE_SECRET_PARAM_KEY = 'shr';

const useShareSecret = () => {
  const [params] = useSearchParams();
  return params.get(SHARE_SECRET_PARAM_KEY) ?? undefined;
};

export default useShareSecret;
